module.exports = __webpack_public_path__ + "img/ads_mail_2recruit.7d49cd17.png";